import { FILE_MANAGMENT_END_POINTS } from "../libs/endpoints";

const getFileUrl = (id: string) => {
  const formatedEndpoint = `${process.env.REACT_APP_FILES_MANAGMENT_BASE_URL}${FILE_MANAGMENT_END_POINTS.DOWNLOAD}`;

  return `${formatedEndpoint}/${id}`;
};

export { getFileUrl };
